import { Box, Chip, styled } from '@mui/material';

export const Grade = styled(Chip)(({ theme }) => ({
	background: theme.palette.primary.main,
	color: theme.palette.primary.contrastText,
}));

export const Wrapper = styled(Box)(() => ({
	display: 'flex',
	flexDirection: 'column',
	overflow: 'hidden',
	padding: '0 16px',
	gap: '16px',
}));
